namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class CurrenciesGrid extends Serenity.EntityGrid<CurrenciesRow, any> {
        protected getColumnsKey() { return CurrenciesColumns.columnsKey; }
        protected getDialogType() { return CurrenciesDialog; }
        protected getIdProperty() { return CurrenciesRow.idProperty; }
        protected getInsertPermission() { return CurrenciesRow.insertPermission; }
        protected getLocalTextPrefix() { return CurrenciesRow.localTextPrefix; }
        protected getService() { return CurrenciesService.baseUrl; }
        protected getIsActiveProperty() { return CurrenciesRow.isActiveProperty; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}
